import * as React from 'react'

import { timeFormats } from 'config/Vars'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import type PersonalForm from 'modules/settings/lib/forms/Personal'

interface Props {
  personalForm: PersonalForm
}

const TimeFormatSelector = (props: Props) => {
  const label = (format: number) => (+format === 12 ? '1:00 PM' : '13:00')

  const options = timeFormats.map((format) => ({
    value: format,
    label: label(format),
  }))

  return (
    <Select
      showOriginalLabelText
      label={i18n.t('personal_settings.time_format')}
      options={options}
      field={props.personalForm.get('time_format')}
    />
  )
}

export default observer(TimeFormatSelector)
